import { CommonModule } from "@angular/common";
import {
	ChangeDetectionStrategy,
	Component,
	CUSTOM_ELEMENTS_SCHEMA,
	DestroyRef,
	inject
} from "@angular/core";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { AlertsService } from "@shared/components/atlas/alerts/services";
import { GLOBAL_ALERT_KEY } from "@shared/components/atlas/alerts/types";
import { SharePaymentLinkModalData } from "./types";
import { BehaviorSubject } from "rxjs";
import { AtlasModalService } from "@shared/services/atlas/modal/atlas-modal.service";

@Component({
	selector: "app-share-payment-link-modal",
	imports: [CommonModule, ClipboardModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	templateUrl: "./share-payment-link-modal.component.html",
	styleUrl: "./share-payment-link-modal.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharePaymentLinkModalComponent {
	private alertsService = inject(AlertsService);
	private atlasModalService = inject(AtlasModalService);
	private window = inject(Window);
	destroyRef = inject(DestroyRef);

	data: SharePaymentLinkModalData = {
		email: "",
		phone: "",
		paymentLink: ""
	};

	private emailRequest = new BehaviorSubject<"DONE" | "LOADING">("DONE");
	emailRequest$ = this.emailRequest.asObservable();

	protected showAlertAfterLinkIsCopied(): void {
		this.alertsService.success({
			key: GLOBAL_ALERT_KEY,
			message:
				"Link da proposta comercial foi copiado para sua área de transferência."
		});
		this.atlasModalService.closeModal();
	}

	protected sendEmail(): void {
		this.emailRequest.next("LOADING");
	}

	protected showAlertAfterEmailIsSent(): void {
		this.alertsService.success({
			key: GLOBAL_ALERT_KEY,
			message: `Email enviado com sucesso para ${this.data.email}.`
		});
	}

	protected openWhatsappLink(): void {
		const message = `Olá, gostaria de compartilhar um link de pagamento: ${this.data.paymentLink}`;
		this.window.open(
			`https://wa.me/${this.data.phone}?text=${message}`,
			"_blank",
			"noopener"
		);
		this.atlasModalService.closeModal();
	}

	handleEmailRequest(status: "DONE" | "LOADING"): void {
		this.emailRequest.next(status);
		if (status === "DONE") {
			this.showAlertAfterEmailIsSent();
			this.atlasModalService.closeModal();
		}
	}
}
